import * as React from 'react';

import type { OperationalViewClient } from '@/api/operational-view-client';
import { HttpOperationalViewClient } from '@/api/operational-view-client.http';

// =============================================================================
// operational-view-client-context.tsx — Injection du OperationalViewClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S14) : l'adaptateur HTTP RÉEL
// (HttpOperationalViewClient) — le câblage front↔back contre le contrat de routes figé D1. Les
// tests de composant injectent le StubOperationalViewClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session admin). */
const defaultOperationalViewClient: OperationalViewClient =
  new HttpOperationalViewClient();

const OperationalViewClientContext =
  React.createContext<OperationalViewClient>(defaultOperationalViewClient);

export interface OperationalViewClientProviderProps {
  client?: OperationalViewClient | undefined;
  children: React.ReactNode;
}

export function OperationalViewClientProvider({
  client = defaultOperationalViewClient,
  children,
}: OperationalViewClientProviderProps): React.JSX.Element {
  return (
    <OperationalViewClientContext.Provider value={client}>
      {children}
    </OperationalViewClientContext.Provider>
  );
}

export function useOperationalViewClient(): OperationalViewClient {
  return React.useContext(OperationalViewClientContext);
}
